module.exports = __webpack_public_path__ + "img/appointments_black.119c700e.svg";